import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class LiveChatWidgetAddon {
  constructor() {
    _defineProperty(this, "isEnabled", {
      fieldName: 'is_enabled',
      content: false
    });
    _defineProperty(this, "accountId", {
      fieldName: 'account_id',
      content: null
    });
    _defineProperty(this, "widgetId", {
      fieldName: 'widget_id',
      content: null
    });
  }
}